import { merchantApi } from '@/config/axios'

/** B 端运力经营台 · 运单监控（merchant-api） */

export interface DispatchActResult {
  success: boolean
  message?: string
}

export interface AuditEvent {
  eventId: string
  action: string
  actor: string
  waybillId?: string
  detail?: string
  at?: string
}

const BASE = '/merchant-api/capacity/dispatch'

export const releaseToPool = (waybillId: string, orgId?: string) =>
  merchantApi.post<DispatchActResult>({
    url: `${BASE}/release`,
    params: { waybillId, orgId }
  })

export const overflowT1 = (waybillId: string) =>
  merchantApi.post<DispatchActResult>({
    url: `${BASE}/overflow-t1`,
    params: { waybillId }
  })

export const reassign = (orgId: string, waybillId: string, toPhone: string) =>
  merchantApi.post<DispatchActResult>({
    url: `${BASE}/reassign`,
    params: { orgId, waybillId, toPhone }
  })

export const goOffline = (phone: string) =>
  merchantApi.post<DispatchActResult>({
    url: `${BASE}/rider/offline`,
    params: { phone }
  })

export const deactivateSilent = (orgId: string, phone: string) =>
  merchantApi.post<DispatchActResult>({
    url: `${BASE}/rider/deactivate`,
    params: { orgId, phone }
  })

export const forceDeactivate = (orgId: string, phone: string, toPhone: string) =>
  merchantApi.post<DispatchActResult>({
    url: `${BASE}/rider/force-deactivate`,
    params: { orgId, phone, toPhone }
  })

export const cancelWaybill = (waybillId: string) =>
  merchantApi.post<DispatchActResult>({
    url: `${BASE}/cancel`,
    params: { waybillId }
  })

export const getT1 = () =>
  merchantApi.get<{ t1Seconds: number }>({ url: `${BASE}/rules/t1` })

export const setT1 = (seconds: number) =>
  merchantApi.post<DispatchActResult>({
    url: `${BASE}/rules/t1`,
    params: { seconds }
  })

export const listAudits = () =>
  merchantApi.get<AuditEvent[]>({ url: `${BASE}/audits` })

export const listMessages = (phone: string) =>
  merchantApi.get<string[]>({ url: `${BASE}/messages`, params: { phone } })
